import "./StoreInfoCard.scss";
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory, useParams, Link } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { get_lang } from "../../../../global-functions/apiGlobal";
import IconButton from "@mui/material/IconButton";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import noImg from "../../../js/assets/images/no-image.svg";
import { Button, useMediaQuery } from "@material-ui/core";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Edit } from "@mui/icons-material";
import { ReactComponent as InfoIcon } from "../../../js/assets/images/info.svg"
import { ReactComponent as MeetOrigin } from "../../../js/assets/images/meet-origin.svg"
import { Skeleton } from "@material-ui/lab";
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import PaymentIcon from '@mui/icons-material/Payment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TableBarIcon from '@mui/icons-material/TableBar';
import RoomServiceIcon from '@mui/icons-material/RoomService';
const StoreInfoCardV2  = (props) => {
  const appDispatch = useDispatch();
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const [branchName, setBranchName] = useState("");
  const min452 = useMediaQuery("(min-width:452px)");
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(true)
  const [table, setTable] = useState("");
  const [pickup, setPickup] = useState("");
   

  const handleSourceOfMeet = () => {
    appDispatch({
      type: "setSourceOfMeetBanner",
      sourceOfMeetBannerImage: true,
    });
  };

  useEffect(() => {
    const getBranchTable = () => {

      if (Boolean(appState.qrBranch)) {
        let flag = true;
        if (appState.storeInfo.branch != null) {
          let branchData = appState.storeInfo.branch;
          if (branchData.id == appState.qrBranch) {
            setBranchName(branchData.name);
            appDispatch({
              type: "setBranch",
              branch: branchData.name,
            });
          }
        }
        if (appState.storeInfo.pickup != null) {
          let pickupData = appState.storeInfo.pickup;
          if (pickupData.id == appState.qrPickup) {
            setPickup(pickupData.name.en);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        } else if (appState.storeInfo.table != null) {
          let tableData = appState.storeInfo.table;
          if (tableData.id == appState.qrTable) {
            setTable(tableData.name);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      }
    };
    if (appState.qrBranch) {
      getBranchTable();
    }
  }, [appState.qrBranch, appState.storeInfo.branch]);


  return (
    <>
      <div id="mySidenav" className={`StoreInfoCardV2  px-0  ${appState?.langValue === "ar" ? "StoreInfoCardV2   MainArabic" : " " }`} >
        <div className="BannerParent">
          <div className="px-2   w-100">
            <div className=" tableShow  mb-3 mt-3 py-3">

              <div className={`d-flex align-items-start justify-content-between flex-wrap mb-2`} style={{ textAlign: appState.langValue === "ar" ? "right" : "left", }} >
                <div className={`d-flex align-items-center flex-wrap `}> 
                   <div className={`logo-div`}>
                     <img src={appState.storeInfo.logo ? `${appState.storeInfo.logo}` : { noImg } } className="img-fluid" alt="" />
                   </div>

                   <h3 className="familyPoppins700 storeName mx-2 "> {get_lang(appState.storeInfo.businessName, appState.langValue)}
                   {appState.qrBranch != null && (<p className={` text-secondary store-branch-name m-0 ${ appState.langValue === "ar" ? "text-right" : "text-left" }`} > {get_lang(branchName, appState.langValue)} </p> )}
                   </h3>
                </div>
                <div className=""> 
                <div className={ `${appState.sourceOfMeetBanner && !min452 ? `d-flex  ` : ``} align-items-center justify-content-end` } >
                  {appState.sourceOfMeetBanner && (
                    <Link to="/" className={`p-0 m-0 ${min452 ? "mx-1" : "mb-1"} `} >
                        <Button variant="text" className={`infoBtn-store-info px-2  ${appState.langValue === "ar" ? "text-right" : "text-left"}  `}  startIcon={<MeetOrigin/>}  onClick={() => handleSourceOfMeet()} >   
                          <span className={appState.langValue === "ar" ? "mr-2" : ""}>  {t("side-bar.source-of-meet")} </span>   
                        </Button>
                    </Link>
                  )}

                  <Link to="/contact" className={`p-0 m-0 ${ appState.storeInfo.disabledBtns ? `pe-none` : `` }   `} >
                    <IconButton aria-label="" onClick={undefined}  className={`infoBtn-store-info ${appState.storeInfo.disabledBtns ? `pe-none` : `` } ${appState.langValue === "ar" ? "mr-1" : ""}`}>
                      <InfoIcon />
                   </IconButton>
                  </Link>
               </div>
                
            <div className="d-flex align-items-center justify-content-end mx-2">
                   {appState.acceptedPayments.length > 0 && appState?.acceptedPayments.map((item, index) => {
                     return (
                     <React.Fragment key={index}>
                     {item == "apple_pay" ? (<span key={index}> <img className={`${appState?.langValue === "ar"? 'mr-1' : 'ml-1'} img-pro`} width="0" src={`/images/apple-pay.png`}  alt={item}/> </span>) : ("")}
                     {item == "cashable" ? (<span key={index}> <img className={`${appState?.langValue === "ar"? 'mr-1' : 'ml-1'} img-pro`} width="25" src={`/images/simpleCash.png`}  alt={item}/> </span>) : ("")}
                     {item == "knet" ? (<span key={index}> <img className={`${appState?.langValue === "ar"? 'mr-1' : 'ml-1'} img-pro`} width="30" src={`/images/Knet.png`}  alt={item}/> </span>) : ("")}
                     {item == "card" ? (<span key={index}> <img className={`${appState?.langValue === "ar"? 'mr-1' : 'ml-1'} img-pro`} width="20" src={`/images/visa-small.png`}  alt={item}/> </span>) : ("")}
                     {item == "wallets" ? (<span key={index}> <img className={`${appState?.langValue === "ar"? 'mr-1' : 'ml-1'} img-pro`} width="20" src={`/images/quickpay-small.png`}  alt={item}/> </span>) : ("")}
                     </React.Fragment>
                     );
                   })}
           </div>
            
         </div>
                
              </div>
             {/* <div className="d-flex align-items-center pb-1 "> <i className="icons-class"> <PaymentIcon /> </i> <span className="mx-2 option-text d-flex align-items-center justify-content-between w-100" >
              <span>
              {t("Payment Methods")}
              </span>
             
            </span>
          </div> */}
          <div className="d-flex align-items-center pb-1 "> 
          
          </div>

                {appState.deliveryMode && appState.deliveryAddsInfo &&
                 <div className="d-flex align-items-center pb-1"> 
                  <i className="icons-class"> <LocationOnIcon /> </i> 
                  <span className="mx-2 option-text d-flex align-items-center align-item-center justify-content-between w-100" >
                  <span>
                    <span> {appState.deliveryAddsInfo?.city_name  ? get_lang(appState.deliveryAddsInfo?.city_name, appState.langValue)  : `City`} </span>
                    <span className={` px-1 ${ appState.langValue === "ar" ? "text-right familyGraphikArabic" : "text-left familyPoppins300" }`} >
                      {appState.deliveryAddsInfo?.area_name ? ` >  ${get_lang( appState.deliveryAddsInfo?.area_name, appState.langValue )}` : ` >  Area`}
                    </span>
                  </span>
                  <span>
                    <Button variant="text" className="option-text" onClick={() => appDispatch({ type: "setDeliveryAddsPopup", deliveryAddsPopup: true }) }> {t('Change')} </Button>
                  </span>
                  </span>
                </div>}

                {(!appState.deliveryMode &&  appState.qrTable && appState.qrBranch) &&
                 <div className="d-flex align-items-center pb-1"> 
                  <i className="icons-class"> <TableBarIcon /> </i> 
                  <span className="mx-2 option-text d-flex align-items-center align-item-center justify-content-between w-100" >
                  <span>
                    <span className={` px-1 ${ appState.langValue === "ar" ? "text-right familyGraphikArabic" : "text-left familyPoppins300" }`} >
                      {t('Table No')}
                    </span>
                  </span>
                  <span>
                    {table}
                  </span>
                  </span>
                </div>}

                {(!appState.deliveryMode &&  appState.qrPickup && appState.qrBranch) &&
                 <div className="d-flex align-items-center pb-1"> 
                  <i className="icons-class"> <RoomServiceIcon /> </i> 
                  <span className="mx-2 option-text d-flex align-items-center align-item-center justify-content-between w-100" >
                  <span>
                    <span className={` px-1 ${ appState.langValue === "ar" ? "text-right familyGraphikArabic" : "text-left familyPoppins300" }`} >
                      {t('Pickup')}
                    </span>
                  </span>
                  <span>
                    {pickup}
                  </span>
                  </span>
                </div>}

         
       
             
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withTranslation()(StoreInfoCardV2);
